(() => {
  'use strict';
  if (window.__SQ_CARD_STABLE_V7__) return;
  window.__SQ_CARD_STABLE_V7__ = true;
  window.__SQ_CARD_STABLE_V6__ = true;
  window.__SQ_CARD_STABLE_V5__ = true;
  window.__SQ_CARD_STABLE_V4__ = true;

  /* Collection/Home structural owner only.
     Favorite interaction = Search favorite controller.
     Bag render = Search universal bag.
     Bag open = universal expanded opener.
     Touch reveal = mobile interaction authority.
     Controls remain anchored to the media container. */
  const CARD = '[data-sq-universal-card]';
  const PILL = '[data-sq-variant-pill]';
  const FAVORITE = '[data-sq-universal-favorite]';
  const HEART_MARKUP = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 21s-7.15-4.35-9.55-8.65C.72 9.24 2.55 5.55 6.1 5.15A5.05 5.05 0 0 1 12 8.05a5.05 5.05 0 0 1 5.9-2.9c3.55.4 5.38 4.09 3.65 7.2C19.15 16.65 12 21 12 21Z"></path></svg>';
  const root = () => String(window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');

  function productUrl(card) {
    try {
      const url = new URL(card.dataset.productUrl || '', location.origin);
      const variant = card.dataset.selectedVariantId || '';
      if (variant) url.searchParams.set('variant', variant);
      return `${url.pathname}${url.search}`;
    } catch (_) { return card.dataset.productUrl || '#'; }
  }

  function syncLinks(card) {
    card.querySelectorAll('[data-sq-product-link]').forEach(link => {
      if (link instanceof HTMLAnchorElement) link.href = productUrl(card);
    });
  }

  function syncTriggerIdentity(card, button) {
    if (!(button instanceof HTMLElement)) return;
    const variantId = card.dataset.selectedVariantId || card.dataset.variantId || '';
    const data = {
      productId: card.dataset.productId || '',
      productHandle: card.dataset.productHandle || '',
      productTitle: card.dataset.productTitle || '',
      productUrl: productUrl(card),
      variantId,
      selectedVariantId: variantId,
      productImage: card.dataset.productImage || '',
      productPrice: card.dataset.productPrice || ''
    };
    Object.entries(data).forEach(([key, value]) => {
      if (String(value || '').trim()) button.dataset[key] = String(value).trim();
      else delete button.dataset[key];
    });
  }

  function requestFavoriteSync(card) {
    const button = card?.querySelector(FAVORITE);
    if (!button) return;
    if (window.SQFavoriteCardControls?.syncButton) window.SQFavoriteCardControls.syncButton(button);
    else document.dispatchEvent(new CustomEvent('sq:favorite-controls:sync', { detail: { scope: card } }));
  }

  function controlHost(card) {
    return card?.querySelector?.('.sq-universal-card__media') || card;
  }

  function ensureRuntimeControls(card) {
    if (!(card instanceof HTMLElement) || !card.matches(CARD)) return null;

    if (card.dataset.sqRuntimeControls === 'true') {
      card.querySelectorAll(':scope > [data-sq-card-favorite-control],:scope > .sq-card-favorite-control').forEach(node => node.remove());

      let heart = card.querySelector(FAVORITE);
      if (!(heart instanceof HTMLButtonElement)) {
        heart = document.createElement('button');
        heart.type = 'button';
        heart.className = 'sq-card-favorite-control';
        heart.setAttribute('data-sq-card-favorite-control', '');
        heart.setAttribute('data-sq-universal-favorite', '');
        heart.setAttribute('aria-pressed', 'false');
        heart.innerHTML = HEART_MARKUP;
        controlHost(card).appendChild(heart);
      }

      let trigger = card.querySelector('[data-sq-collection-home-trigger][data-sq-universal-expanded-open]');
      if (!(trigger instanceof HTMLButtonElement) && card.dataset.productAvailable !== 'false') {
        trigger = document.createElement('button');
        trigger.type = 'button';
        trigger.className = 'sq-universal-card-trigger';
        trigger.setAttribute('data-sq-universal-expanded-open', '');
        trigger.setAttribute('data-sq-collection-home-trigger', '');
        trigger.setAttribute('aria-haspopup', 'dialog');
        trigger.setAttribute('aria-expanded', 'false');
        controlHost(card).appendChild(trigger);
      }
      if (trigger) {
        syncTriggerIdentity(card, trigger);
        trigger.setAttribute('aria-label', `Choose options for ${card.dataset.productTitle || 'product'}`);
      }
    } else {
      const trigger = card.querySelector('[data-sq-universal-expanded-open]');
      if (trigger) syncTriggerIdentity(card, trigger);
    }

    requestFavoriteSync(card);
    if (window.SQUniversalBag?.ensureCard) window.SQUniversalBag.ensureCard(card);
    else document.dispatchEvent(new CustomEvent('sq:universal-bag:ensure', { detail: { card } }));
    return card;
  }

  function chooseVariant(pill) {
    const card = pill.closest(CARD);
    if (!card) return;
    card.dataset.selectedVariantId = pill.dataset.variantId || '';
    card.dataset.productImage = pill.dataset.hoverSrc || card.dataset.productImage || '';
    card.dataset.productPrice = pill.dataset.hoverPrice || card.dataset.productPrice || '';
    card.dataset.productComparePrice = pill.dataset.hoverCompare || '';

    const image = card.querySelector('.sq-universal-card__image');
    if (image instanceof HTMLImageElement && pill.dataset.hoverSrc) {
      image.src = pill.dataset.hoverSrc;
      if (pill.dataset.hoverSrcset) image.srcset = pill.dataset.hoverSrcset;
    }
    const currentPrice = card.querySelector('[data-sq-current-price]');
    if (currentPrice && pill.dataset.hoverPrice) currentPrice.textContent = pill.dataset.hoverPrice;
    const compare = card.querySelector('[data-sq-compare-price]');
    if (compare) {
      compare.textContent = pill.dataset.hoverCompare || '';
      compare.hidden = !pill.dataset.hoverCompare;
    }
    card.querySelectorAll(PILL).forEach(item => {
      const active = item === pill;
      item.classList.toggle('is-active', active);
      item.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    syncLinks(card);
    syncTriggerIdentity(card, card.querySelector('[data-sq-universal-expanded-open]'));
    window.SQUniversalBag?.refreshRim?.(card, pill);
    requestFavoriteSync(card);
  }

  function updateCartCount(cart) {
    if (!cart) return;
    const count = Math.max(0, Number(cart.item_count) || 0);
    const label = count > 99 ? '99+' : String(count);
    document.querySelectorAll('[data-cart-count],[data-cart-count-number],.cart-count-bubble span[aria-hidden="true"]').forEach(element => {
      element.textContent = label;
    });
  }

  async function refreshCartCount() {
    try {
      const response = await fetch(`${root()}cart.js`, {
        credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' }
      });
      if (response.ok) updateCartCount(await response.json());
    } catch (_) {}
  }

  function initializeSlider(slider) {
    if (!(slider instanceof HTMLElement) || slider.dataset.ready) return;
    slider.dataset.ready = '1';
    const rail = slider.querySelector('[data-product-slider-track]');
    if (!rail) return;
    const step = () => (rail.querySelector(CARD)?.getBoundingClientRect().width || rail.clientWidth * .75) + 16;
    slider.querySelector('[data-sq-slider-prev]')?.addEventListener('click', () => rail.scrollBy({ left: -step(), behavior: 'smooth' }));
    slider.querySelector('[data-sq-slider-next]')?.addEventListener('click', () => rail.scrollBy({ left: step(), behavior: 'smooth' }));
  }

  function initializeInfiniteScroll() {
    if (!document.querySelector('[data-sq-collection-infinite="true"]')) return;
    document.querySelectorAll('#ResultsList .product-grid').forEach(grid => {
      if (grid.dataset.sqInfinite) return;
      grid.dataset.sqInfinite = '1';
      let page = Math.max(1, ...[...grid.querySelectorAll(':scope>[data-page]')].map(item => Number(item.dataset.page) || 1));
      let last = Number(grid.dataset.lastPage) || page;
      let loading = false;
      for (let node = grid.nextElementSibling; node; node = node.nextElementSibling) node.classList.add('sq-infinite-pagination-hidden');
      const sentinel = document.createElement('div');
      sentinel.className = 'sq-infinite-scroll__sentinel';
      sentinel.innerHTML = '<span class="sq-infinite-scroll__spinner"></span><span>Loading more products</span>';
      grid.after(sentinel);
      const complete = () => {
        sentinel.className = 'sq-infinite-scroll__sentinel is-complete';
        sentinel.innerHTML = '<span>All products loaded</span>';
        observer.disconnect();
      };
      const load = async () => {
        if (loading || page >= last) { if (page >= last) complete(); return; }
        loading = true;
        try {
          const url = new URL(location.href);
          url.searchParams.set('page', String(page + 1));
          const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'text/html' } });
          if (!response.ok) throw new Error(String(response.status));
          const nextDocument = new DOMParser().parseFromString(await response.text(), 'text/html');
          const nextGrid = nextDocument.querySelector('#ResultsList .product-grid');
          if (!nextGrid) throw new Error('Product grid was not found.');
          last = Math.max(last, Number(nextGrid.dataset.lastPage) || last);
          const ids = new Set([...grid.querySelectorAll(':scope>[data-product-id]')].map(item => item.dataset.productId));
          const fragment = document.createDocumentFragment();
          let added = 0;
          nextGrid.querySelectorAll(':scope>.product-grid__item').forEach(item => {
            if (ids.has(item.dataset.productId)) return;
            ids.add(item.dataset.productId);
            fragment.append(item);
            added += 1;
          });
          if (!added) { page = last; complete(); }
          else { grid.append(fragment); page += 1; initialize(grid); if (page >= last) complete(); }
        } catch (_) {
          sentinel.className = 'sq-infinite-scroll__sentinel is-error';
          sentinel.textContent = 'Tap to retry loading products';
        } finally { loading = false; }
      };
      sentinel.addEventListener('click', () => { if (sentinel.classList.contains('is-error')) void load(); });
      const observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) void load();
      }, { rootMargin: '900px' });
      observer.observe(sentinel);
      if (page >= last) complete();
    });
  }

  function initialize(scope = document) {
    const cards = [];
    if (scope instanceof Element && scope.matches(CARD)) cards.push(scope);
    scope.querySelectorAll?.(CARD).forEach(card => cards.push(card));
    [...new Set(cards)].forEach(card => {
      ensureRuntimeControls(card);
      syncLinks(card);
      requestFavoriteSync(card);
    });
    if (scope instanceof Element && scope.matches('[data-sq-universal-slider]')) initializeSlider(scope);
    scope.querySelectorAll?.('[data-sq-universal-slider]').forEach(initializeSlider);
    initializeInfiniteScroll();
  }

  document.addEventListener('pointerover', event => {
    const target = event.target instanceof Element ? event.target : null;
    const pill = target?.closest(PILL);
    if (pill && event.pointerType !== 'touch') chooseVariant(pill);
  }, true);
  document.addEventListener('focusin', event => {
    const target = event.target instanceof Element ? event.target : null;
    const pill = target?.closest(PILL);
    if (pill) chooseVariant(pill);
  }, true);
  document.addEventListener('click', event => {
    const target = event.target instanceof Element ? event.target : null;
    const pill = target?.closest(PILL);
    if (!pill) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    chooseVariant(pill);
  }, true);

  document.addEventListener('sq:universal-product-card:ensure', event => {
    const card = event.detail?.card;
    if (card instanceof HTMLElement) initialize(card);
  });

  const start = () => {
    initialize(document);
    const pending = Array.isArray(window.__SQ_PENDING_UNIVERSAL_CARD_CONTROLS__)
      ? window.__SQ_PENDING_UNIVERSAL_CARD_CONTROLS__.splice(0) : [];
    pending.forEach(card => { if (card instanceof HTMLElement) initialize(card); });
    void refreshCartCount();
    new MutationObserver(records => {
      records.forEach(record => record.addedNodes.forEach(node => {
        if (node instanceof Element) initialize(node);
      }));
    }).observe(document.body, { childList: true, subtree: true });
  };

  window.SQUniversalProductCard = Object.assign(window.SQUniversalProductCard || {}, {
    ensureControls: ensureRuntimeControls,
    initialize,
    syncHeart(card) { requestFavoriteSync(card); }
  });

  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', start, { once: true }) : start();
  window.addEventListener('pageshow', refreshCartCount);
  window.addEventListener('sq:cart:updated', event => updateCartCount(event.detail?.cart));
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
